import { confirmation, destruction, information } from 'frontend/utils/modals';

export const appointmentEnded = isHostLostConnection =>
  confirmation({
    title: isHostLostConnection ? 'Your clinician lost connection' : 'Appointment ended',
    text: isHostLostConnection
      ? 'You can rejoin the appointment and wait for your clinician.'
      : 'Your clinician left and ended the appointment.',
    confirmButtonText: isHostLostConnection ? 'Rejoin appointment' : 'OK',
    allowOutsideClick: false,
    showCancelButton: false,
  });

export const ensureAppointmentEnding = () =>
  destruction({
    title: 'End appointment?',
    text: 'This will end the video appointment for all participants.',
    input: 'checkbox',
    inputValue: 0,
    inputPlaceholder: "Don't ask again",
    customClass: {
      input: 'show-again-checkbox',
    },
    cancelButtonText: 'Cancel',
    confirmButtonText: 'End',
  });

export const ensureStopWhiteboardSharing = () =>
  destruction({
    title: 'Are you sure you want to stop sharing?',
    text: 'When you stop sharing, any unsaved changes will be lost.',
    cancelButtonText: 'Cancel',
    confirmButtonText: 'Stop sharing',
  });

export const cannotStartSharing = () =>
  information({
    title: 'You can not start sharing',
    text: 'Other participant started sharing before you',
    confirmButtonText: 'OK',
  });

export const cannotChangeSettings = () =>
  information({
    title: "We can't change your settings",
    text: 'Please, check your internet connection and try again.',
    confirmButtonText: 'Try again',
  });
